export function replaceTemplateTags(text: string, replaceTag: (tag: string) => string): string {
	let output = "";
	let cursor = 0;

	while (cursor < text.length) {
		const openIndex = text.indexOf("{{", cursor);
		if (openIndex === -1) {
			return output + text.slice(cursor);
		}

		output += text.slice(cursor, openIndex);
		const tagStart = openIndex + 2;
		const closeIndex = text.indexOf("}}", tagStart);
		if (closeIndex === -1) {
			return output + text.slice(openIndex);
		}

		const tag = text.slice(tagStart, closeIndex);
		output += tag.length === 0 || /[\r\n]/.test(tag) ? `{{${tag}}}` : replaceTag(tag);
		cursor = closeIndex + 2;
	}

	return output;
}
